// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__HSaxm","img":"Banner_img__pSpeH","title":"Banner_title__X6CQO"};